
export type NotificationListResponseNotificationsItemTarget = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
